import React from 'react';
import { Box, Chip, Alert } from '@mui/material';

export default function WatcherList({ watchers = [], onRemove, error, onDismissError }) {
  return (
    <Box>
      {error && (
        <Alert severity="error" onClose={onDismissError} sx={{ mb: 1 }}>
          {error}
        </Alert>
      )}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {watchers.map((w) => (
          <Chip
            key={w.userId}
            label={w.userName || w.userId}
            size="small"
            onDelete={() => onRemove(w.userId)}
          />
        ))}
      </Box>
    </Box>
  );
}
